<input matInput 
	(input)="searchCountry()"
	(focusin)="setFocusIn()"
	(focusout)="setFocusOut($event)"
	#countryInput
	[matAutocompleteConnectedTo]="connectedFormField()"
	[formControl]="formControl" 
	[matAutocomplete]="auto"
	(blur)="markTouched()"/>
<mat-autocomplete #auto="matAutocomplete" 
	class="select__panel--surface"
	[displayWith]="displayCountry"
	[root]="auto.panel"
	appIntersectionObserver 
	requireSelection
	(intersecting)="loadCountries()"
	(optionSelected)="markTouched()"
		rootMargin="0px 0px 20% 0px" >
		@if(selectableCountries()?.data; as countries){
			@for (country of countries; track country.isoCodeTwo; let last = $last) {
				@if(last){
					<mat-option
						[value]="country"
						appObserve>{{country.name}}</mat-option>
				}
				@else {
					<mat-option
						[value]="country">
						{{country.name}}</mat-option>
				}
			}
	}
</mat-autocomplete>